<template>
  <div id="confluence-card">
    <div id="confluence-result" :key="index"
      v-for="(result, index) in confluenceResults">
      <div class="confluence-item" :id="`confluence-item-${index}`"
        :class=" preloadedResult ? 'unique' : ''"
      >
        <div class="item-title">
          <router-link :to="{
            path:`${routeKey}/page/${result.id}`}"
            class="title-style" ref="routerLink"
            v-if="!preloadedResult"
          >
            {{ result.title }}
          </router-link>
          <a class="title-style" ref="routerLink"
            v-if="preloadedResult"
          >
            {{ result.title }}
          </a>
        </div>
        <div class="conf-content">
          <div id="sliced-body" v-if="!preloadedResult"
            v-show="confluenceOpenedIndex != index"
          >
            <div class="conf-body"
              v-html="slicedContent(result.body.view.value)"
            ></div>
            <span v-if="result.body.view.value.length>1000">...</span>
          </div>
          <div id="expanded-body" class="conf-body"
            v-show="confluenceOpenedIndex === index"
            v-html="result.body.view.value"
          ></div>
        </div>
        <div class="conf-lines">
          <div class="conf-expander"
            v-if="result.body.view.value.length>1000 && !preloadedResult"
          >
          <img class="icon vertical expander"
            src="/static/material_icons/expand_more.png"
            @click="openConfluence(index);"
            v-show="confluenceOpenedIndex != index"
          />
          <img class="icon vertical expander"
            src="/static/material_icons/expand_less.png"
            @click="openConfluence(index);"
            v-show="confluenceOpenedIndex === index"
          />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-restricted-globals: ["off", "screen"] */
import store from '../../store/Store';

export default {
  name: 'confluenceCard',
  store,
  props: [
    'preloadedResult',
    'routeKey',
  ],

  computed: {
    confluenceOpenedIndex() {
      return this.$store.state.confluenceOpenedIndex;
    },
    confluenceResults() {
      if (this.preloadedResult) {
        return this.preloadedResult;
      }
      return this.$store.state.confluenceResults;
    },
  },

  created() {
    // Automatically expand the body if singleView
    if (this.preloadedResult) {
      this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', 0);
    }
  },

  data() {
    return {
      confluenceUrl: 'https://confluence.geops.ch/' +
        'pages/viewpage.action?pageId=',
    };
  },

  methods: {
    openConfluence(index) {
      if (this.confluenceOpenedIndex === index) {
        this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', -1);
      } else {
        this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', index);
      }
      this.$nextTick(() => {
        this.scrollConfDiv(index);
      });
    },

    slicedContent(text) {
      // Slice content without cutting words in pieces
      const shortenedText = text.slice(0, 1000);
      const returnedText = shortenedText.substr(
        0,
        Math.min(shortenedText.length, shortenedText.lastIndexOf(' ')),
      );
      return returnedText;
    },

    scrollConfDiv(index) {
      const element = this.$el.querySelector(`div #confluence-item-${index}`);
      element && element.scrollIntoView && element.scrollIntoView();
      window.scrollBy(0, -160);
    },
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";

#confluence-card {
  max-width: $sd-max-width;
  margin: auto;
}

#confluence-card img {
  max-width: 100%;
}

.confluence-item {
  padding-top: 25px;
  margin-bottom: 40px;
  background: #ffffff;
  box-shadow: $sd-box-shadow;
}

.unique {
  margin-bottom: 80px;
}

.confluence-item a:hover {
  color: $sd-color-dark-blue;
  opacity: 0.8;
}

.conf-content {
  margin: 15px 5% 0 5%;
  text-align: left;
}

.conf-body a, .conf-body a:visited {
  color: $sd-color-blue;
}

.conf-lines {
  display: flex;
  width: 100%;
}

.conf-expander {
  padding-top: 12px;
  margin: auto;
}

.table-wrap table {
  word-break: break-word;
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100% !important;
}

.table-wrap th,
.table-wrap td {
  display: table-cell;
  border: 1px solid #ddd;
  padding: 7px 7px;
  vertical-align: top;
  text-align: left;
}
.table-wrap th {
  background-color: #f0f0f0;
  font-size: 13px;
}

pre {
  white-space: pre-wrap;
}

time {
  padding: 1px 1px 1px 1px;
  border-radius: 10%;
  background-color: #f0f0f0;
}

@media (max-width: 720px) {
  .table-wrap {
    font-size: 8px;
  }
  .table-wrap th {
    font-size: 7px;
  }
  .table-wrap h1,
  .table-wrap h2,
  .table-wrap h3,
  .table-wrap h4,
  .table-wrap h5,
  .table-wrap h6 {
    font-size: 8px;
  }

  .table-wrap ul {
    -webkit-padding-start: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// ConfluenceCard.vue?6737f0ab